module.exports = __webpack_public_path__ + "img/21_44.9267bcf3.png";